<template>
  <section>
    <div style="color: #397f1f; font-weight: 600; font-size: 1.5rem; margin: 2rem 0">我的檔案</div>
    <div style="font-weight: 600; font-size: 1.3rem; margin: 1rem 0">基本資料</div>
    <div class="profile-container">
        <div class="profile-userIcon">
          <img id="img_profile_src" :src="profile_img">
          <form id="icon_form">
            <input type="file" id="file_profile_img" name="profile_img" accept="image/*" @change="select_file">
          </form>
          <el-button type="primary" id="upload_btn" @click="open_selector" v-if="this.role === 'teacher'">更改個人頭像</el-button>
         </div>
        <div class="profile-userInfo">
          <form id="profile_form">
            <div class="profile-userInfo-details">
              <div class="profile-label">名稱:</div>
              <div style="align-self: center; text-align: right" class="profile-field" id="label_name">{{first_name + ' ' + last_name}}</div>
              <div id="field_name" style="width:100%; display: none; align-self: center;">
                <input class="profile-field" name="first_name" :value="first_name" style="display:none; width: 40%">
                <input class="profile-field" name="last_name" :value="last_name" style="display:none; width: 55%; float: right">
              </div>
            </div>
            <div class="profile-userInfo-details">
              <div class="profile-label">電郵:</div>
              <div style="align-self: center;" class="profile-field" id="label_email">{{email}}</div>
            </div>
            <div class="profile-userInfo-details">
              <div class="profile-label">學校名稱:</div>
              <div style="align-self: center;" class="profile-field" id="label_school">{{school_faculty}}</div>
              <div id="field_school" style="width: 100%; display: none; align-self: center;">
                <input class="profile-field" name="school_faculty" :value="school_faculty" style="display:none; width: 100%">
              </div>
            </div>
            <div class="profile-userInfo-details">
              <div class="profile-label">個人簡介:</div>
              <div style="align-self: center;" class="profile-field" id="label_summary">{{summary}}</div>
              <div id="field_summary" style="width: 100%; display: none; align-self: center;">
                <input class="profile-field" name="summary" :value="summary" style="display:none; width: 100%">
              </div>
            </div>
          </form>
          <div style="text-align: right; padding-top: 1rem;" v-if="this.role === 'teacher'">
            <el-button type="primary" id="btn-edit" @click="edit_profile_info">編輯個人資料</el-button>
            <div style="display:none;" id="btn_cancel_ok">
              <el-button plain @click="cancel_edit">取消</el-button>
              <el-button class="save-btn" type="primary" @click="confirm_edit">完成</el-button>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.profile-userInfo-details{
  display: flex;
  flex-wrap: wrap;
}

.profile-label{
  flex: 0 0 100px;
  margin: 1rem 0;
}

.profile-field{
  // flex: 1;
  padding: 0 1rem;
}

.profile-container{
  background-color: #f5f5f5;
  padding: 2rem 5rem;
  border-radius: 2.5rem;
  font-size: 1.2rem;
}
.profile-left{
  flex: 0 0 15rem;
}
.profile-right{
  flex: 1;
}
.profile-userIcon{
  align-self: center;
}
.profile-userInfo{
  padding-left: 3rem;
  font-size: 1.2rem;
  align-self: center;
  position: relative;
}
#upload_btn{
  display: block;
  margin: 1rem auto 0 auto;
  font-weight: 600;
}

#upload_btn:hover{
  cursor: pointer;
  text-decoration: underline;
}
#btn-edit{
  // color: #397f1f;
  font-weight: 600;
}
#btn-edit:hover{
  text-decoration: underline;
  cursor: pointer;
}
#img_profile_src{
    width: 15rem;
    height: 15rem;
    background: #e9e9e9;
    border-radius: 50%;
    display: block;
    overflow: hidden;
}

input{
  border-radius: 1rem;
}
input:focus{
  box-shadow: 0 0 3px 0px #397f1f;
  outline: none;
}
label{
  align-self: center;
}

.wordbtn{
  color: #397f1f;
  font-weight: 600;
  padding-left: 1rem;
}
.wordbtn:hover{
  text-decoration: underline;
  cursor: pointer;
}
  @media screen and (max-width: 790px) {
.profile-container{
  display: block;
  padding: 1rem;
  justify-content: center;
  font-size: 1rem;
}
.profile-userIcon{
  width: 50%;
  margin: auto;
}
.profile-userInfo{
  padding-left: 1rem;
}.profile-label{
  flex: auto;
}
#img_profile_src{
    width: auto;
    height: auto;
    border-radius: 50%;
}
}

</style>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      // id: '',
      // first_name: '',
      // last_name: '',
      // email: '',
      // school_faculty: '',
      // summary: '',
      // profile_img: '',
      // role: ''
    }
  },
  methods: {
    get_profile_info: function () {
      // console.log(Object.assign(this, this.$store.getters.user))
      // console.log(this)
      // this.$store.dispatch('getProfile').then(r => {
      //   this.id = r.id
      //   this.first_name = r.first_name
      //   this.last_name = r.last_name
      //   this.email = r.email
      //   this.school_faculty = r.school_faculty
      //   this.summary = r.summary
      //   this.profile_img = r.profile_img !== null && r.profile_img.length !== 0 ? r.profile_img : require('@/assets/image/user_default.png')
      //   this.role = r.role
      // })
    },
    edit_profile_info: function () {
      $('#btn-edit').hide()
      $('#btn_cancel_ok').show()
      $('#label_name').hide()
      $('#label_school').hide()
      $('#label_summary').hide()
      $('#field_name').show()
      $('#field_school').show()
      $('#field_summary').show()
      $('input[name="first_name"]').show()
      $('input[name="first_name"]').attr('fabu-data', function () { return $(this).val() })
      $('input[name="last_name"]').show()
      $('input[name="last_name"]').attr('fabu-data', function () { return $(this).val() })
      $('input[name="school_faculty"]').show()
      $('input[name="school_faculty"]').attr('fabu-data', function () { return $(this).val() })
      $('input[name="summary"]').show()
      $('input[name="summary"]').attr('fabu-data', function () { return $(this).val() })
    },
    cancel_edit: function () {
      $('#btn-edit').show()
      $('#btn_cancel_ok').hide()
      $('#label_name').show()
      $('#label_school').show()
      $('#label_summary').show()
      $('#field_name').hide()
      $('#field_school').hide()
      $('#field_summary').hide()
      $('input[name="first_name"]').hide()
      $('input[name="first_name"]').val(function () { return $(this).attr('fabu-data') })
      $('input[name="last_name"]').hide()
      $('input[name="last_name"]').val(function () { return $(this).attr('fabu-data') })
      $('input[name="school_faculty"]').hide()
      $('input[name="school_faculty"]').val(function () { return $(this).attr('fabu-data') })
      $('input[name="summary"]').hide()
      $('input[name="summary"]').val(function () { return $(this).attr('fabu-data') })
    },
    confirm_edit: function () {
      let fd = new FormData(document.getElementById('profile_form'))
      this.$store.dispatch('request', {
        method: 'post',
        route: `profile`,
        data: fd
      }).then(r => {
        $('#btn-edit').show()
        $('#btn_cancel_ok').hide()
        $('#label_name').show()
        $('#label_school').show()
        $('#label_summary').show()
        $('#field_name').hide()
        $('#field_school').hide()
        $('#field_summary').hide()
        let newName = $('input[name="first_name"]').val() + ' ' + $('input[name="last_name"]').val()
        $('#label_name').text(newName)
        $('#user_name').text(newName)
        $('input[name="first_name"]').hide()
        $('input[name="last_name"]').hide()
        $('input[name="school_faculty"]').hide()
        $('input[name="summary"]').hide()
        let newSchool = $('input[name="school_faculty"]').val()
        let newSummary = $('input[name="summary"]').val()
        $('#label_school').text(newSchool)
        $('#label_summary').text(newSummary)
        if (r === undefined) {
          this.successMessage('編輯個人資料成功')
        }
      })
        .catch(r => {
          this.errorMessage(r)
        })
    },
    open_selector: function () {
      $('#file_profile_img').click()
    },
    select_file: function () {
      this.upload_profile_icon()
    },
    upload_profile_icon: function () {
      this.$emit('loading')
      let fd = new FormData(document.getElementById('icon_form'))
      this.$store.dispatch('request', {
        method: 'post',
        route: `profile/icons`,
        data: fd
      }).then(r => {
        this.$emit('loaded')
        console.log(r)
        $('#img_profile_src').attr('src', r)
        this.$store.dispatch('getProfile')
        $('#file_profile_img').val('')
        this.successMessage('更改個人頭像成功')
      })
    },
    successMessage (message) {
      this.$message({
        showClose: true,
        message: message,
        type: 'success'
      })
    },
    errorMessage (r) {
      this.$alert(r, '錯誤', {
        confirmButtonText: 'OK'
      })
    }
  },
  computed: {
    id: function () {
      return this.$store.getters.user.id
    },
    first_name: function () {
      return this.$store.getters.user.first_name
    },
    last_name: function () {
      return this.$store.getters.user.last_name
    },
    email: function () {
      return this.$store.getters.user.email
    },
    school_faculty: function () {
      return this.$store.getters.user.school_faculty
    },
    summary: function () {
      return this.$store.getters.user.summary
    },
    profile_img: function () {
      return this.$store.getters.user.profile_img
    },
    role: function () {
      return this.$store.getters.user.role
    }
  },
  mounted () {
    // this.get_profile_info()
    this.$store.dispatch('getProfile')
    console.log(this.$store.getters.user)
  }
}
</script>
